import React from "react";
import { renderRichText } from "src/services/PrismicService";
import TeamLogo from "src/components/Team/TeamLogo";
import { UpgradeButton } from "src/components/UpgradeButton";
import styles from "./style.scss";
import { WebSportItem } from "src/constants";

type GameAnalysisProps = {
  event: any;
  currentSportObj: WebSportItem;
  prismicGame: any;
};

const GameAnalysis = ({ event, currentSportObj, prismicGame }: GameAnalysisProps) => {
  const doc = prismicGame;
  const autoPredictionIfRestricted = `Read a full ${currentSportObj.name} preview of ${event.awayTeam.fullName} and ${
    event.homeTeam.fullName
  }${event.stadium ? ` playing at ${event.stadium}` : ""}.`;
  const autoPredictionRestricted = Boolean(event.analysis === "");
  const hasAutoPrediction = Boolean(event.analysis || event.analysis === "");
  const autoPrediction = autoPredictionRestricted ? autoPredictionIfRestricted : event.analysis;
  const hasManualPrediction =
    Boolean(doc) &&
    Boolean(
      doc.intro_paragraph?.[0]?.text ||
        doc.home_team_preview?.[0].text ||
        doc.away_team_preview?.[0].text ||
        doc.full_game_prediction?.[0].text
    );

  const makeTeamLogo = (team: any, size: number) => (
    <TeamLogo
      containerClassName="team-logo"
      leagueName={currentSportObj.key}
      teamAbbreviation={
        event[team === "away" ? "awayTeam" : "homeTeam"][currentSportObj.isTennis ? "country" : "preferredAbbreviation"]
      }
      size={size}
    />
  );

  return (
    <React.Fragment>
      <article className="prediction-article-group" id="prediction">
        <div className="preview-betfacts-group">
          {hasAutoPrediction ? (
            <div className="prediction-section">
              <h1 className="prediction-title">
                <span className="prediction-team">
                  {makeTeamLogo("away", 32)}
                  {event.awayTeam.fullName}
                </span>
                <span className="vs"> vs</span>
                <span className="prediction-team">
                  {makeTeamLogo("home", 32)}
                  {event.homeTeam.fullName} Prediction
                </span>
              </h1>
              <p
                className="prediction-text"
                dangerouslySetInnerHTML={{ __html: autoPrediction?.replace(/\n/g, "<br />") }}
              />
              {autoPredictionRestricted && (
                <UpgradeButton className="upgrade-button" game={event} source="Auto Prediction">
                  Read Full Prediction
                </UpgradeButton>
              )}
            </div>
          ) : null}

          {hasManualPrediction && (
            <div className="preview-prediction-section">
              {Boolean(doc.intro_paragraph?.[0]?.text) && (
                <React.Fragment>
                  <h2>
                    {event.awayTeam.fullName} vs {event.homeTeam.fullName} Prediction{" "}
                  </h2>
                  {renderRichText(doc.intro_paragraph)}
                </React.Fragment>
              )}
              <h2>
                {event.homeTeam.fullName} Preview {makeTeamLogo("home", 32)}
              </h2>
              {renderRichText(doc.home_team_preview)}
              <h2>
                {event.awayTeam.fullName} Preview {makeTeamLogo("away", 32)}
              </h2>
              {renderRichText(doc.away_team_preview)}
              <h2>Full Game Prediction</h2>
              {renderRichText(doc.full_game_prediction)}
            </div>
          )}
        </div>

        {hasManualPrediction && doc.author && (
          <div className="prediction-author-section">
            <img className="author-image lazyload" data-src={doc.author.photo.url} alt={doc.author.full_name} />
            <div className="author-text">
              <div className="author-written-by">Prediction Written by</div>
              <div className="author author-name">{doc.author.full_name}</div>
              <div className="author-summary">{renderRichText(doc.author.summary)}</div>
            </div>
          </div>
        )}

        <style jsx>{styles}</style>
      </article>
    </React.Fragment>
  );
};

export default GameAnalysis;
